// third-party
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

// reducer
import rootReducer from './rootReducer';
import version from './version';

function load() {
    let state;

    try {
        state = localStorage.getItem('state');

        if (typeof state === 'string') {
            state = JSON.parse(state);
        }

        if (state && state.version !== version) {
            state = undefined;
        }

        // Kerkimi nuk rikthehet nga localStorage, as ai i ruajtur nga versionet e meparshme.
        if (state) {
            delete state.tableSearch;
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }

    return state || undefined;
}

const store = createStore(rootReducer, load(), compose(
    applyMiddleware(thunk),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
));

function save() {
    try {
        // Kerkimi (rezultatet me pronare e kontakte, tokenat e detajeve, kriteret) mbetet vetem
        // ne memorie: humb me refresh dhe nuk mbetet ne kompjuter (p.sh. kompjutere te perbashket).
        const { tableSearch, ...pjesaTjeter } = store.getState();
        localStorage.setItem('state', JSON.stringify(pjesaTjeter));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

store.subscribe(() => save());

// Mbishkruan menjehere gjendjen e ruajtur, qe kerkimet e vjetra te fshihen edhe pa asnje veprim.
save();

export default store;
